module.exports = __webpack_public_path__ + "img/card_pet_sitter_200.a4395960.jpg";